<template>
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="1.28374"
      y="1.28374"
      width="25.0483"
      height="25.0483"
      rx="6.3412"
      stroke="currentColor"
      stroke-width="0.567486"
    />
    <rect
      x="5.42401"
      y="11.1132"
      width="3.53879"
      height="11.4686"
      fill="currentColor"
    />
    <ellipse
      cx="7.20759"
      cy="7.13983"
      rx="2.23502"
      ry="2.16729"
      fill="currentColor"
    />
    <path
      d="M14.8967 22.5814L14.9836 16.2601C14.9985 15.1764 15.7348 14.5443 16.1011 14.3637C16.4671 14.1805 16.8404 14.0178 17.3174 14.0178C18.0272 14.0178 18.5366 14.2384 18.9414 14.6346C19.2208 15.041 19.407 15.2216 19.5002 16.2601L19.5884 22.5814H23.1321V15.3162C23.1321 14.4297 23.0325 13.648 22.6664 13.0091C22.3004 12.3653 21.8364 11.8206 21.1764 11.474C20.5165 11.1273 19.5959 10.9773 18.7086 10.9773C17.7603 10.9773 17.0567 11.1346 16.1476 11.5191C15.4299 11.8609 15.037 12.2415 14.8142 12.6965H14.7587V11.1306H11.3051L11.3529 22.5814H14.8967Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "LinkedIn"
};
</script>
